import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';

import { ICertificateTypeListItemFragment } from 'graphql/types';
import { isCertificateSelected } from 'training/utils/certificateSelect';
import { CertificateSelectorListItem } from 'common/components/CertificateSelectorListItem';

interface IProps {
    addedCertificates: ICertificateTypeListItemFragment[];
    selectedCertificates: ICertificateTypeListItemFragment[];
    certificates: ICertificateTypeListItemFragment[];
    onAddCertificate?(
        selectedCertificate: ICertificateTypeListItemFragment
    ): void;
    onRemoveCertificate?(
        selectedCertificate: ICertificateTypeListItemFragment
    ): void;
}

export const CertificateAddList = ({
    addedCertificates,
    selectedCertificates,
    certificates,
    onAddCertificate,
    onRemoveCertificate,
}: IProps) => {
    const [translate] = useTranslation();

    return (
        <>
            {!certificates.length ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 7,
                    }}
                >
                    <Typography>
                        {translate('noOptionsText.certificates')}
                    </Typography>
                </Box>
            ) : (
                certificates.filter(Boolean).map((certificate) => {
                    const isSelected = isCertificateSelected(
                        selectedCertificates,
                        certificate
                    );
                    const isAdded = isCertificateSelected(
                        addedCertificates,
                        certificate
                    );

                    return (
                        <CertificateSelectorListItem
                            addButton
                            added={isAdded}
                            certificate={certificate}
                            key={certificate.id}
                            selected={isSelected}
                            onClick={() =>
                                isSelected
                                    ? onRemoveCertificate?.(certificate)
                                    : onAddCertificate?.(certificate)
                            }
                        />
                    );
                })
            )}
        </>
    );
};
